export default {

  //Dialog Defaults
  ok: 'OK',
  cancel: 'Cancel',
  yes: 'Yes',
  no: 'No',
  close: 'Close',
  download: 'Download',

  //Dashboard.vue

  //Desktop.vue
  back: 'Back',
  home: 'Home',
  overview: 'Overview',
  overviewDesc: 'Show Folders & Favourites',
  reload: 'Reload',
  more: 'More',
  viewmodeList: 'List',
  viewmodeSymbols: 'Symbols',
  viewmodeCards: 'Cards',
  viewmodeDashboard: 'Dashboard',
  viewmodeTable: 'Table',
  updateApp: 'Update App',
  updateAppDesc: 'Empty cache and reload.',
  export: 'Export',
  exportDesc: 'Download Resultset',
  exportXLSX: 'Download XLSX.',
  exportODS: 'Download ODS.',
  exportCSV: 'Download CSV.',
  changePW: 'Change password',
  changePWDesc: 'Set new login password.',
  changeLanguage: 'Change language',
  changeLanguageDesc: 'Language',
  changeSetting: 'Settings',
  changeSettingDesc: 'Set Defaultvalues',
  help: 'Help',
  helpDesc: 'App documentation',
  systemTest: 'System test',
  systemTestDesc: 'Test system compatibility',
  info: 'Info',
  version: 'Version',
  releaseNotes: 'Release notes',
  logout: 'Logout',
  loggedInAs: 'Loggin in as',
  folder: 'Folder',
  favorites: 'Favorites',
  readingParamsError: 'Error reading parameters.',
  favoriteToStart: 'Favorite for "',
  favoriteToRemoved: '" removed',
  favoriteSaveError: 'Error setting favorite.',
  favoriteListGetError: 'Error reading favorites list.',
  logoutError: 'Logout error',
  logoutErrorDesc: 'Please validate your username and password.',

  //Detail.vue
  queries: 'Queries',
  formulars: 'Forms',
  documents: 'Documents',
  framelinks: 'Framelinks',
  noElementsInFolder: 'No folders, queries, forms or documents found.',
  favoriteToSet: '" created',
  categoryListError: 'Error reading category list.',
  queryListError: 'Error reading query list.',

  //DocumentView.vue
  documentError: 'Error reading document.',

  //Formular.vue
  emptyFieldsDlgTitle: 'Missing required fields',
  emptyFieldsDlgMessage: 'Some required fields are not set. You can finish editing this form later. Would you like to save and exit?',
  savingFormular: 'Saving form...',
  fileUploadError: 'Technical error while saving file uploads.',
  formularPersistError: 'Error saving form.',
  formularPersisted: 'Form saved.',
  downloadSuccess: 'Download success.',
  downloadError: 'Download error.',
  pluginCallError: 'Error calling plugin',
  validatingInputs: 'Validating inputs...',
  presafeCheckError: 'Technical error while executing pre save checks.',
  dependantFieldRefreshError: 'Error updating dependant form fields.',
  formularLoading: 'Form loading',
  formularLoadingError: 'Error loading form fields.',
  formularNotSaved: 'Your form inputs have not yet been saved. Leave anyway?',

  //Framelink.vue
  framelinkLoadingError: 'Error loading framelink.',

  //Login.vue
  reloadClearCache: 'Reload app, clear cache',
  resetPassword: 'Reset password',
  login: 'Login',
  username: 'Username',
  password: 'Password',
  enterUsername: 'Please insert your username',
  passwordReset: 'Password reset',
  passwordResetDesc: 'Password successfully reset. You will receive a new password through mail shortly.',
  loginError: 'Login error',
  loginErrorDesc: 'Please validate your username and password.',
  passwordResetError: 'Error resetting password',
  passwordResetNameNotFound: 'Username not found.',
  passwordResetNameNotUnique: 'Username is not unique.',
  passwordResetMailFailed: 'Sending mail failed.',
  passwordResetInvalidUsername: 'This person does not have a valid username.',
  passwordResetInactiveUser: 'The user account is not activated.',
  passwordResetNoUsername: 'No username given.',
  passwordResetInvalidMail: 'This person does not have a valid mail address.',

  //Parameter.vue
  useFormularStandardValues: 'Enter form default values',
  execute: 'Execute',
  filter: 'Filter',
  wrongParamValues: 'Invalid parameter values',
  wrongParamValuesDesc: 'Please correct the invalid parameter values.',

  //Query.vue
  queryTabParameter: 'Parameter',
  queryTabResult: 'Table',
  queryTabDetail: 'Detail',
  queryTabEdit: 'Edit',
  queryTabChart: 'Chart',
  queryTabPlugin: 'Plugin',
  queryTabWebentity: 'Webentity',
  querySearch: 'Search',
  restartAutorefresh: 'Restart autorefresh',
  stopAutorefresh: 'Stop autorefresh',
  fullscreen: 'Fullscreen',
  fullscreenOnOff: 'Fullscreen on/off',
  resetChartZoom: 'Reset chart zoom',
  enableDisableRows: 'Enable or disable rows',
  rowsPerPage: 'Rows per page',
  copyToClipboard: 'Copy to clipboard',
  showDetails: 'Show details',
  edit: 'Edit',
  queryExportODS: 'Export ODS',
  queryExportCSV: 'Export CSV',
  maxPostComma: 'Maximum amount of decimal places: ',
  maxPreComma: 'Maximum amount of pre decimal point positions: ',
  columnUpdateSuccess: '" successfully updated',
  columnUpdateError: 'Error updating "',
  dataExporting: 'Data exporting',
  downloadOf: 'Downloading "',
  downloadOfSuccess: '" successful.',
  exportError: 'Error during export.',
  actionCallErrorTitle: 'Error calling action with query parameters',
  actionCallErrorDescStart: 'Action with nativename "',
  actionCallErrorDescEnd: '" does not exist.',
  actionExecuting: 'Action executing',
  actionCallErrorGlobal: 'Error executing query action.',
  actionParseError: 'This query has columns that include spaces, slashes or backslashes in their name. These columns could not be parsed.',
  queryDefinitionError: 'Error reading query.',
  paramLoadingError: 'Error reading parameters from Query.vue',
  queryExecutionError: 'Error executing query',
  actionListError: 'Error reading query actions.',
  fileDownloadError: 'Error on file download.',
  fileDownloadErrorNoSQLResult: 'Error on file download - BLOB from SQL was null.',
  columnDomainErrorStart: 'Value domain for "',
  columnDomainErrorEnd: '" could not be loaded.',
  noVisibleColumnsError: 'Alert: no columns visible, please validate result column declarations',
  exportNoColumnIncluded: 'No column configured for export.',

  //QueryApp.vue

  //SingleRecordView.vue
  update: 'Update',
  noPrimaryKeyError: 'No primary for query set.',
  updateSuccess: 'Updates successful',
  fieldUpdateError: 'Field could not be updated',
  valuedomainColumnStart: 'Value domain for "',
  valuedomainColumnEnd: '" could not be loaded.',

  //Webentity.vue
  noWebentityDataFound: 'No data found.',

  //fldRichtext.vue
  moveIn: 'indent',
  moveOut: 'outdent',
  moveInTooltip: 'indent paragraph',
  moveOutTooltip: 'outdent paragraph',
}
